import { defineNuxtPlugin } from '#app'

import {
  KeyOfLifeCalendarViewType,
  KeyOfLifeKanbanViewType,
  KeyOfLifeTimelineViewType,
  KeyOfLifeMapViewType,
} from '@keyoflife-views/viewTypes'

export default defineNuxtPlugin({
  name: 'keyoflife-views',
  dependsOn: ['core', 'database'],
  setup(nuxtApp) {
    const { $registry } = nuxtApp
    const context = { app: nuxtApp }

    $registry.register('view', new KeyOfLifeCalendarViewType(context))
    $registry.register('view', new KeyOfLifeKanbanViewType(context))
    $registry.register('view', new KeyOfLifeTimelineViewType(context))
    $registry.register('view', new KeyOfLifeMapViewType(context))
  },
})
